export const DEFAULT_ZOOM = 1
export const MIN_ZOOM = 0.5
export const MAX_ZOOM = 5
export const BUTTON_ZOOM_LEVEL = 0.2
export const WHEEL_ZOOM_LEVEL = 1.05
export const DOUBLE_CLICK_ZOOM_LEVEL = 1.5
